import React, { useEffect, useState, useRef } from 'react';
import { Container } from './styles';

import WebFont from "webfontloader";
import LogoErpWorks from "~/assets/logos/Logo ErpWorks Full.png";

function OsTemplate({ data }) {

  return (
    <>
      <div>
        {data?.map((thisItem, a) => (
          thisItem?.map((thisOs, b) => (
            <Container>
              <div className="barra-sup"></div>
              <div className="header">
                <img src={LogoErpWorks} alt="Logo Erpworks" />
                <div class="text">
                  <p class="titulo">Data da OS</p>
                  <p class="titulo-data">{thisOs?.dataEmissaoMascara}</p>
                </div>
              </div>
              <div className="body">
                <div className="top">
                  <div class="text">
                    <p class="titulo">{thisOs?.projeto?.titulo}</p>
                    <p class="sub-titulo">Coordenador(a): {thisOs?.coordenador?.nome + " / " + thisOs?.coordenadorTec?.nome}</p>
                  </div>
                  <div className="numero-os">
                    <p class="titulo">#NUM{thisOs?.id}</p>
                  </div>
                </div>
                <div className="mid">
                  <div className="colunas">
                    <div className="col">
                      <p className="titulo">Total Trabalhado</p>
                    </div>
                    <div className="col">
                      <p className="titulo">Total Desconto</p>
                    </div>
                    <div className="col">
                      <p className="titulo">Total Translado</p>
                    </div>
                    <div className="col">
                      <p className="titulo">Total de Horas</p>
                    </div>
                  </div>
                  <div className="linhas">
                    <div className="col">
                      <p className="titulo">{(thisOs?.horaApontadaMascara + "").replace(":", "h")}</p>
                    </div>
                    <div className="col">
                      <p className="titulo">{(thisOs?.horaDescontoMascara + "").replace(":", "h")}</p>
                    </div>
                    <div className="col">
                      <p className="titulo">{(thisOs?.horaTransladoMascara + "").replace(":", "h")}</p>
                    </div>
                    <div className="col ativo">
                      <p className="titulo">{(thisOs?.horaTotalMascara + "").replace(":", "h")}</p>
                    </div>
                  </div>
                </div>
                <div className="bottom">
                  <div class="text">
                    <p class="titulo">{thisOs?.titulo}</p>
                    <p class="sub-titulo">Data: {thisOs?.dataEmissaoMascara}</p>
                  </div>
                  {thisOs?.atividades?.map((thisAtiv, c) => (
                    <div class="atividade">
                      <p class="titulo">{thisAtiv?.projetoAtividade?.titulo}</p>
                      <pre class="sub-titulo">{thisAtiv?.descricao}</pre>
                    </div>
                  ))}
                </div>
              </div>
              <div className="footer">
                <div className="analista">
                  <span className="barra-assina"></span>
                  <div class="text">
                    <p class="titulo">Analista</p>
                    <p class="sub-titulo">{thisOs?.analista?.nome}</p>
                  </div>
                </div>
                <div className="cliente">
                  <span className="barra-assina"></span>
                  <div class="content">
                    <img src={thisOs?.cliente?.arquivo?.url} alt="Logo Erpworks" />
                    <span className="barra-verti"></span>
                    <div class="text">
                      <p class="titulo">{thisOs?.cliente?.nomeFantasia}</p>
                      <p class="sub-titulo">{thisOs?.projeto?.solicitante_cliente?.nome}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Container >
          ))
        ))}
      </div>
    </>
  );
};

export default OsTemplate;